module.exports = __webpack_public_path__ + "img/admin.9d1c62a8.jpeg";